module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_20_2.227e988f.jpeg";